@for (row of formArray?.controls; track $index; let idx = $index) {  
    <div [formGroup]="row" #properties>
      @if (editStates().get(idx)?.isEditing) {
        <div class="edit-mode flex flex-row gap-2">
          <div class="flex flex-row gap-1">
          <mat-form-field appearance="outline">
            <input matInput formControlName="name" [matAutocomplete]="auto" placeholder="Type field name" maxlength="50"/>
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of suggestions() | textFilter: row.get('name').value; track option) {
                <mat-option [value]="option">{{option}}</mat-option>
              }
            </mat-autocomplete>
            @if (row.get('name').invalid) {
                <mat-error >
                  @if (row.get('name').errors?.required) {
                    Name is required
                  }@else if (
                    row.get('name').errors?.exist
                  ) {
                    Name already exists
                  }@else {
                    Error
                  }
                </mat-error>
              }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <input matInput formControlName="value" placeholder="Type field value" maxlength="1000"/>
            @if (row.get('value').invalid) {
                <mat-error >
                  @if (row.get('value').errors?.required) {
                    Value is required
                  }@else {
                    Error
                  }
                </mat-error>
              }
          </mat-form-field>
          </div>
          <div class="actions flex flex-row gap-1">
              <button
                mat-icon-button 
                color="primary"
                (click)="saveRow(idx)"
                [disabled]="row.invalid"
                type="button"
              >
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="primary" type="button" (click)="cancelEdit(idx)">
                  <mat-icon>close</mat-icon>
              </button>
          </div>
        </div>
    } @else {
      <div class="display-mode flex flex-row gap-2">
        <div class="flex flex-1 flex-row gap-1 w-full">
          <div class="flex-1 flex align-items-center">
            <div class="field-value">{{ row.get('name').value }}</div>
          </div>
          <div class="flex-1 flex align-items-center">
            <div class="field-value">{{ row.get('value').value }}</div>
          </div>
        </div>
        <div class="actions flex flex-row gap-1">
          <button mat-icon-button color="primary" type="button" (click)="enableEdit(idx)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" type="button" (click)="removeRow(idx)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
    </div>
  }

  <button mat-button color="primary" type="button" class="full-width" (click)="addRow()" #addButton  [disabled]="disabled()">
    <mat-icon class="notranslate" color="primary">add</mat-icon>
    Add Custom Field
  </button>